import React, { useContext } from 'react';

import PersonContext from '@/pages/Person/PersonContext';
import { ShowMoreText, Typography } from '@/ui';

import type { Props } from './types';

const PersonRecoveryGoal = ({ maxLines = 2 }: Props) => {
  const { person } = useContext(PersonContext);

  const recoveryGoal = person?.recovery_goal?.trim();

  return (
    <div className="mt-2">
      {!recoveryGoal ? (
        <Typography muted>No goal set.</Typography>
      ) : (
        <ShowMoreText className="mp-sensitive whitespace-pre-line" maxLines={maxLines}>
          {recoveryGoal}
        </ShowMoreText>
      )}
    </div>
  );
};

export default React.memo(PersonRecoveryGoal);
